import MIGRATOR_ABI from './migrator.json'

const MIGRATOR_ADDRESS = '0x6801F280Ef5d238C5A76e0D9B5569097eD35b0D6'

export { MIGRATOR_ADDRESS, MIGRATOR_ABI }
